import { render, staticRenderFns } from "./SimplePass.vue?vue&type=template&id=5b56367c&"
import script from "./SimplePass.vue?vue&type=script&lang=js&"
export * from "./SimplePass.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports